import { Box, CloudinaryVideo, ResponsiveSection, useBelowBreakpoint } from '@stitch-fix/mode-react';
import { CloudinaryPicture } from '../CSCloudinaryAsset/Picture';
import { type CloudinaryImageFields } from '../CloudinaryImageWrapper';
import { parseCloudinaryVideoUrl } from '../../utils/parseCloudinaryUrl/parseCloudinaryUrl';
import { formatAspectRatio } from '../CloudinaryImageWrapper/CloudinaryImageWrapper';
import { ModuleWrapper, ModuleWrapperProps } from '../ModuleWrapper';
import { ModularComponentProps } from '../ModularPageWrapper/ModularPageWrapper';
import styles from './styles.module.scss';
type DisplayMediaTextColor = 'blue-45' | 'mint-60' | 'white' | 'forest-60' | 'grapefruit-60' | 'citrus-60';
type DisplayMediaBackgroundColor = 'blue-45' | 'mint-60' | 'white' | 'gray-95' | 'gray-99';
export type DisplayMediaProps = {
  backgroundColor: DisplayMediaBackgroundColor;
  majorTitleTextColor?: DisplayMediaTextColor;
  media: {
    mobile: CloudinaryImageFields;
    desktop: CloudinaryImageFields;
  };
  minorTitleTextColor?: DisplayMediaTextColor;
} & Omit<ModuleWrapperProps, 'children'>;
export const DisplayMedia = ({
  alignment,
  backgroundColor,
  majorTitleTextColor,
  media,
  minorTitleTextColor,
  moduleTitle,
  verticalSpacing
}: DisplayMediaProps & ModularComponentProps) => {
  const isMobile = useBelowBreakpoint(560);
  const selectedMedia = isMobile ? media.mobile : media.desktop;
  const renderMedia = () => {
    if (selectedMedia.src.includes('mp4')) {
      const {
        baseUrl,
        mediaPath
      } = parseCloudinaryVideoUrl(selectedMedia.src);
      return <Box className={styles.video}>
          <CloudinaryVideo key={selectedMedia.src} baseUrl={baseUrl} mediaPath={mediaPath} intent="decorative"
        /* Ideally we could use something like 100vw, but since we can't we use the max of the viewport ranges: */ sizes={{
          sm: 560,
          md: 900,
          lg: 1140
        }} aspectRatio={formatAspectRatio(selectedMedia.aspectRatio)} objectFit="cover" />
        </Box>;
    }
    return <CloudinaryPicture alt={media.desktop.alt} sources={[{
      minWidth: 0,
      cloudinaryAsset: media.mobile.cloudinaryAsset
    }, {
      minWidth: 560,
      cloudinaryAsset: media.desktop.cloudinaryAsset
    }]} imageProps={{
      fetchPriority: 'low'
    }} />;
  };
  return <Box bgColor={backgroundColor} mt={verticalSpacing}>
      <ResponsiveSection gutter="none" width="xxlarge">
        <ModuleWrapper alignment={alignment} majorTitleTextColor={majorTitleTextColor} minorTitleTextColor={minorTitleTextColor} moduleTitle={moduleTitle} gutter="standard">
          <Box className={styles.container}>{renderMedia()}</Box>
        </ModuleWrapper>
      </ResponsiveSection>
    </Box>;
};